import axios from "axios";
import tokenApi from '../components/static/Token'

const apiClient = axios.create({
    baseURL: 'https://testrate.coffeemania.io',
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use((config) => {
    const token = tokenApi();
    if (token) {
        config.headers.Authorization = token;
    }
    return config;
});

export default apiClient;